import {
  GAME_ID,
  UPDATE_GAME_PRACTICE_DETAILS,
  UPDATE_GAME_ONBOARDING_DETAILS,
} from '../foodTruckConstants';

const initialState = {
  // no props synchronized with server, only custom props
  highestLevelEarned: 0,
  isQuestOnboardingCompleted: false,
  isPracticeOnboardingCompleted: false,
};

const foodTruckGameDetailsReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case UPDATE_GAME_PRACTICE_DETAILS: {
      const { highestLevelEarned } = payload;

      return {
        ...state,
        highestLevelEarned,
      };
    }
    case UPDATE_GAME_ONBOARDING_DETAILS: {
      const { isQuestWorkflow } = payload;

      return {
        ...state,
        isQuestOnboardingCompleted: isQuestWorkflow || state.isQuestOnboardingCompleted,
        isPracticeOnboardingCompleted: !isQuestWorkflow || state.isPracticeOnboardingCompleted,
      };
    }
    default:
      return state;
  }
};

export default foodTruckGameDetailsReducer;
